import React from 'react'
import Header from '../Layout/Header'
import BlogBanner from './BlogBanner'
import BlogGrid from './BlogGrid'
import Testimonials from '../Home/HomeSections/Testimonials'
import Lorem from '../Home/HomeSections/Lorem'
import Footer from '../Layout/Footer'

export default function Blog() {
  return (
    <div>
        <Header/>
        <BlogBanner/>
        <BlogGrid/>
        <Testimonials/>
        <Lorem/>
        <Footer />
    </div>
  )
}
